// extracted by mini-css-extract-plugin
module.exports = {"button":"Link_button__qJq3k","link":"Link_link__mGpGY"};